import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '@shared/services/auth.service';
import {NavigationService} from 'app/core/navigation/navigation.service';
import {filter, forkJoin, Observable, of, switchMap, take} from 'rxjs';
import {environment} from "@env/environment";
import {tap} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver {
    /**
     * Constructor
     */
    constructor(
        private _navigationService: NavigationService,
        private authService: AuthService
        // private _messagesService: MessagesService,
        // private _notificationsService: NotificationsService,
        // private _quickChatService: QuickChatService,
        // private _shortcutsService: ShortcutsService,
        // private _userService: UserService,
    ) {
        console.log('InitialDataResolver constructor');
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        console.log('InitialDataResolver resolve');
        return this.authService.customerID$.pipe(
            filter(customerID => environment?.pool ? !!customerID : true),
            tap((customerID) => console.log("customerID in resolve --> ", customerID)),
            take(1),
            // Wait for the firestore user (and thus its permissions) BEFORE fetching the navigation,
            // otherwise the sidebar permission filter would run against empty permissions and hide
            // every gated module for members.
            switchMap((customerID) => this.authService.firestoreUser$.pipe(
                filter(user => !!user),
                take(1),
                switchMap((user) => forkJoin([
                    this._navigationService.get(),
                    // this._messagesService.getAll(),
                    // this._notificationsService.getAll(),
                    // this._quickChatService.getChats(),
                    // this._shortcutsService.getAll(),
                    // this._userService.get(),
                    of(customerID),
                    of(user),
                    this.authService.quota$.pipe(filter(quota => !!quota), take(1)),
                    this.authService.algoliaClient$.pipe(filter(algoliaClient => !!algoliaClient), take(1))
                ]))
            ))
        );
    }
}
